module.exports = __webpack_public_path__ + "static/media/1542318313059654545924 - Citizen Datasteward.b8cec1d8.jpg";